<template>
  <div>
    <vs-button
      @click="smsGonder()"
      style="border-radius: 5px; padding-bottom: 0; padding-top: 0"
      color="danger"
      type="gradient"
      icon="sms"
      >Sms At</vs-button
    >
  </div>
</template>
<script>

export default {
  methods: {
    smsGonder() {
      var vm = this;
      var vs = this.$vs;
      console.log(vm.params.data)
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        telNo: vm.params.data.telNo, faturaUrl:vm.params.data.url, orderNumber: vm.params.data.orderNumber,

      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.smsFaturaGonder(args, function (err, result) {
          console.log(result)

          if (result.smsFaturaGonderResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.smsFaturaGonderResult);
            console.log(result)
            vs.notify({
              title: "Sms Gönderim",
              text: "Sms Gönderim Başarılı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center"
            });
          }
        });
      });
    },
  },
};
</script>